/**
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-03-19 15:38:09
 * @LastEditTime: 2021-04-19 17:46:33
 * @FilePath: \buyer-one\dop-webapp\src\components\Lang\Lang.js
 * @Copyright: Copyright 2021-2021, all rights reserved. Essa.cn
 */
import Locale from "../../utils/locale";
import zh from "../../locales/zh.js";
import en from "../../locales/en.js";
import ru from "../../locales/ru.js";

let locale = Locale.current();
let lang = null;

switch (locale) {
    case "en":
        lang = en;
        break;
    case "ru":
        lang = ru;
        break;
    default:
        lang = zh;
        break;
}

var marks = function (mark = "", replaces) {
    var replaceArray = replaces || [];
    if (replaceArray.length === 0) {
        return mark;
    }
    var matches = mark.match(/{\d+}/gi) || [];
    for (var i = 0; i < matches.length; i++) {
        if (matches[i] === undefined) {
            mark = mark.replace(matches[i], matches[i]);
        } else {
            //优化翻译方法，因为有可能出现XXX{1}XX{0}的状况
            var result = /\d+/gi.exec(matches[i]) || [];
            var num = parseInt(result[0]);
            if (replaceArray[num] === undefined) {
                mark = mark.replace(matches[i], matches[i]);
            } else {
                mark = mark.replace(matches[i], replaceArray[num]);
            }
        }
    }
    return mark;
};

const Lang = function (props) {
    let label = lang[props.id];
    if (label && props.params && props.params.length > 0) {
        label = marks(label, props.params);
    }
    //把参数也展示出来
    let params = "";
    if(!label&& props.params && props.params.length > 0){
        params = `；${props.params.join(",")}`
    }
    if (locale !== "zh" && label === undefined) {
        return (label || props.default || props.children || "") + "（" + props.id + params + "）";
    }
    if (props.id === label) {
        if (locale === "zh") {
            return props.default || props.children ;
        } else {
            return props.id;
        }
    } else {
        return label || props.default || props.children || "";
    }
};

export default Lang;
